






























































































































































import { defineComponent, reactive, toRefs, onMounted, ref, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue"
import { BTable } from 'bootstrap-vue';
import { Examinee, SearchCondition } from "../../modules/teacher/SaitenResultDownload"

export interface Data {
  condition: SearchCondition
  examinees: Examinee[]
  isAllCheckDownload: boolean
  errors: string[]
  isDispSheetType: boolean
  labelSheetCode: string
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const SheetTypeEnum = Common.SheetTypeEnum;

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      examinees: [],
      isAllCheckDownload: false,
      errors: [],
      isDispSheetType: false,
      labelSheetCode: "レポートID/試験ID",
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = async () => {
      await search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      state.errors = []

      if(!state.condition.submitted_at_from && !state.condition.submitted_at_to && !state.condition.updated_at_from && !state.condition.updated_at_to){
        state.errors.push("提出日期間、最終更新日期間いずれかを入力してください。");
      }else{
        if((state.condition.submitted_at_from || state.condition.submitted_at_to) && (!state.condition.submitted_at_from || !state.condition.submitted_at_to)){
          state.errors.push("提出日期間で検索する場合は開始日・終了日を入力してください。");
        }

        if((state.condition.updated_at_from || state.condition.updated_at_to) && (!state.condition.updated_at_from || !state.condition.updated_at_to)){
          state.errors.push("最終更新日期間で検索する場合は開始日・終了日を入力してください。");
        }
      }

      // 入力エラーは処理終了
      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("成績情報をダウンロードします。よろしいですか？")){
        return;
      }

      if(!state.isDispSheetType){
        state.condition.sheet_type = context.root.$store.getters.isOptionReportActive ? SheetTypeEnum.Report : SheetTypeEnum.ApprovalExam;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/saiten_result_download?${Common.BuildQuery(state.condition, 'search_condition')}`).then(async response => {
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
        if(state.examinees.length == 0){
          alert("条件に一致するデータはありませんでした。");
        }else{
          await download();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ダウンロード
     ******************************/

    const download = async () => {

      state.errors = []

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/saiten_result_download/result_downloaded_at`, {examinee_ids: state.examinees.map(x => x.examinee_id)}).then(response => {
        let csvData = '';

        const header = [
          "コースCD", "コース名", "キャンパスCD", "キャンパス名", "クラスCD", "クラス名", "生徒CD", "氏名", "学年", "組", "出席番号", "教科CD", "教科名", "科目CD", "科目名", 
          `${Common.isApprovalExamSheetType(state.condition.sheet_type) ? '試験ID' : 'レポートID'}`,
          `${Common.isApprovalExamSheetType(state.condition.sheet_type) ? '試験名' : 'レポート名'}`,
          "提出回数", "合計得点", "観点１得点", "観点２得点", "観点３得点", "提出日時", "公開日時", "標準締切日時", "最終締切日時"
        ];
        csvData += header.join(',') + '\r\n';

        state.examinees.forEach(x => {
          const cols = [];
          cols.push(x.course_code);
          cols.push(x.course_name);
          cols.push(x.campus_code);
          cols.push(x.campus_name);
          cols.push(x.class_code);
          cols.push(x.class_name);
          cols.push(x.student_code);
          cols.push(x.student_name);
          cols.push(x.grade);
          cols.push(x.kumi);
          cols.push(x.student_no);
          cols.push(x.curriculum_code);
          cols.push(x.curriculum_name);
          cols.push(x.subject_code);
          cols.push(x.subject_name);
          cols.push(x.sheet_code);
          cols.push(x.sheet_name);
          cols.push(x.times);
          cols.push(x.score);
          cols.push(x.view_point1_score);
          cols.push(x.view_point2_score);
          cols.push(x.view_point3_score);
          cols.push(x.submitted_at);
          cols.push(x.publish_at);
          cols.push(x.std_deadline_at);
          cols.push(x.final_deadline_at);
          csvData += cols.join(',') + '\r\n';
        });

        const link = document.createElement('a');
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob: any = null;
        const csvName = `生徒成績_${moment().format("YMD")}`;

        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.webkitURL.createObjectURL(blob));
          link.click();
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.isDispSheetType = context.root.$store.getters.isOptionReportActive && context.root.$store.getters.isOptionApprovalExamActive;
      if(!state.isDispSheetType){
        state.labelSheetCode = context.root.$store.getters.isOptionReportActive ? "レポートID" : "試験ID";
      }
    });

    return {
      ...toRefs(state),
      SheetTypeEnum,
      tableRef,
      searchClick,
      search,
      clearCondition,
      download,
    };
  }
});
